import { resetAttachedFile, fetchAttachedFile, attachFile, deleteAttachedFile, fetchReceiveHistoryDetailRecord, editReceiveHistory } from '../../actions/receive_actions';
import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

import PurchasePaymentDetail from '../../components/Purchase/purchasePaymentDetail';

let purchasePaymentDetail = reduxForm({
    form: 'purchasePaymentDetail',
})(PurchasePaymentDetail);

function mapStateToProps(state) {
    return {
        currentReceiveHistory: state.receives.currentReceiveHistory,
        currentReceiveHistoryDetail: state.receives.fetchedReceiveHistoryDetailRecord,
        detailIsLoading: state.receives.isfetchingReceiveHistoryDetail,
        error: state.receives.fetchReceiveHistoryDetailError,
        fetchedAttachedFiles: state.receives.fetchedAttachedFiles,
        initialValues: state.receives.fetchedReceiveHistoryDetailRecord,
        userPermissions: state.auth.userPermissions
    };
}

export default connect(mapStateToProps, { resetAttachedFile, fetchAttachedFile, attachFile, deleteAttachedFile, fetchReceiveHistoryDetailRecord, editReceiveHistory })(purchasePaymentDetail);



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/purchasePaymentDetail.jsx